module.exports = __webpack_public_path__ + "static/media/whats-app.c03f5ed4.svg";